type PluralizeProps = {
  plural: string;
  singular?: string;
};

type SingularizeProps = {
  plural?: string;
  singular: string;
};

type Props = PluralizeProps | SingularizeProps;

export function pluralize(count: number, { singular, plural }: Props): string {
  if (singular && !plural) {
    plural = `${singular}s`;
  }

  if (plural && !singular) {
    singular = plural.substring(0, plural.length - 1);
  }

  return `${count} ${count === 1 ? singular : plural}`;
}
